<template>
  <a-form
    :model="formState"
    name="normal_login"
    class="login-form"
    @finish="onFinish"
  >
    <a-form-item
      label="Email"
      name="email"
      :rules="[{ required: true, message: 'Please input your email!' }]"
    >
      <a-input v-model:value="formState.email">
        <template #prefix>
          <UserOutlined class="site-form-item-icon"/>
        </template>
      </a-input>
    </a-form-item>
    <a-form-item
      label="Password"
      name="password"
      :rules="[{ required: true, message: 'Please input your password!' }]"
    >
      <a-input-password v-model:value="formState.password">
        <template #prefix>
          <LockOutlined class="site-form-item-icon"/>
        </template>
      </a-input-password>
    </a-form-item>
    <a-form-item>
      <a-button :disabled="disabled" type="primary" html-type="submit" class="login-form-button">
        Log in
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      formState: {
        email: '',
        password: '',
      },
    };
  },
  components: {
    UserOutlined,
    LockOutlined,
  },
  methods: {
    onFinish(values) {
      this.login(values);
    },
    ...mapActions({
      login: 'auth/login',
    }),
  },
  computed: {
    disabled() {
      return !(this.formState.email && this.formState.password);
    },
  },
};
</script>
